module.exports = __webpack_public_path__ + "img/linkedin.10b327ac.svg";